import React, { useMemo } from 'react';
import { Button, Skeleton, SkeletonLine, Typography } from '@one-thd/sui-atomic-components';
import { PropTypes } from "prop-types";

const PricePlaceholder = () => (
  <Skeleton disablePadding PaperProps={{ className: 'sui-w-full', variant: 'shadow' }}>
    <SkeletonLine variant="single" numberOfLines={2} />
  </Skeleton>
);

export const QuickEstimateFooter = ({
                                      handleClose,
                                      loading,
                                      groupTotals,
                                      numberOfGroups
                                    }) => {
  const estimatedSubtotal = useMemo(() => {
    let total = 0;
    Object.values(groupTotals).forEach((groupTotal) => {
      total += groupTotal;
    });
    return total;
  }, [groupTotals]);

  const isLoading = loading || Object.keys(groupTotals).length < numberOfGroups;

  return (
    <div className="sui-flex sui-flex-col sui-gap-2 sui-w-full sui-text-right">
      {
        !loading && (
          <>
            <Typography variant="h4" weight="bold">
              Taxes & Fees: <span className="sui-font-regular">Not included</span>
            </Typography>
            <Typography variant="h4" weight="bold">
              Estimated Subtotal:
              {
                isLoading ? (
                  <span className="sui-w-24 sui-pl-2 sui-inline-block">
              <PricePlaceholder />
            </span>
                ) : (
                  <span data-testid="overall-price" className="sui-min-w-24 sui-pl-2 sui-inline-block">
                $
                    {
                      estimatedSubtotal.toFixed(2)
                    }
            </span>
                )
              }
            </Typography>
          </>
        )
      }
      {/* Close Button */}
      <Button
        variant="secondary"
        fullWidth
        onClick={handleClose}
        data-testid="quick-estimate-close-button"
      >
        Close
      </Button>
    </div>
  );
};

QuickEstimateFooter.displayName = 'QuickEstimateFooter';
QuickEstimateFooter.propTypes = {
  handleClose: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  numberOfGroups: PropTypes.number.isRequired,
  groupTotals: PropTypes.shape({})
};
QuickEstimateFooter.defaultProps = {
  loading: false,
  groupTotals: {}
};
